<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useTrackTitle } from '@/composables/useTrackTitle'

/**
 * The tracks of an event as a count, with the list of them in a tooltip.
 *
 * An event card has room for a number, not for a dozen names: the names are one hover away.
 */
const props = defineProps({
  /** Tracks of the event, in the shape the API returns (see EventLib). */
  tracks: { type: Array, default: () => [] },
})

const { t } = useI18n()
const { fullName } = useTrackTitle()

const names = computed(() => props.tracks.map(track => fullName(track.trackKey)))
</script>

<template>
  <v-tooltip v-if="names.length" location="top" max-width="320">
    <template #activator="{ props: activatorProps }">
      <v-chip
        v-bind="activatorProps"
        size="small"
        variant="tonal"
        prepend-icon="mdi-flag-checkered"
        label
        tabindex="0"
      >
        {{ t('events.trackCount', { n: names.length }) }}
      </v-chip>
    </template>

    <div v-for="name in names" :key="name">{{ name }}</div>
  </v-tooltip>
</template>
